import(/* webpackMode: "eager" */ "/home/user/research/amnesties/game/app/page.tsx")